/**
 * chaves — as chaves de cache das ligações do chat (Task 12).
 *
 * Num módulo à parte, sem dependência, porque quem LÊ (a faixa "Entrar" do grupo) e quem INVALIDA (o `useChat`, no
 * `chamada:sala` do canal da sala) precisam da mesma chave: duas cópias do literal divergiriam sem aviso, e a faixa
 * deixaria de aparecer e sumir ao vivo.
 */

/** A ligação em andamento numa conversa (`GET /calls/sala/{roomId}/ativa`). */
export const chaveDaLigacaoNaSala = (roomId: string) => ["ligacao-na-sala", roomId] as const;
